
export default {
    //Ejemplo de etiqueta y texto para objetos generales
    "GeneralObjectLabel": "General Object Text",
}